import React, { useEffect, useRef, useState } from 'react';
import { X } from 'lucide-react';

const ZoomDialog = ({ item, onClose }) => {
  useEffect(() => {
    const h = (e) => e.key === 'Escape' && onClose();
    document.addEventListener('keydown', h);
    document.body.style.overflow = 'hidden';
    return () => { document.removeEventListener('keydown', h); document.body.style.overflow = ''; };
  }, [onClose]);
  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4" data-testid="zoom-dialog">
      <div className="absolute inset-0 bg-black/85 backdrop-blur-sm" onClick={onClose} data-testid="zoom-backdrop" />
      <button onClick={onClose} className="absolute top-4 right-4 z-20 text-white/60 hover:text-white" data-testid="zoom-close" aria-label="Close"><X size={26} /></button>
      {item.video ? (
        <video src={item.src} controls autoPlay muted playsInline loop className="relative z-10 max-w-[96vw] max-h-[92vh] rounded-xl bg-black" data-testid="zoom-video" />
      ) : (
        <img src={item.src} alt={item.alt} className="relative z-10 w-[min(96vw,1400px)] max-h-[92vh] rounded-xl object-contain" onClick={onClose} data-testid="zoom-image" />
      )}
    </div>
  );
};

export const ZoomImage = ({ src, alt, testid }) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button type="button" onClick={() => setOpen(true)} className="block w-full cursor-zoom-in rounded-xl overflow-hidden border border-white/10 hover:border-[#FF7A00]/40 transition-colors" data-testid={testid}>
        <img src={src} alt={alt} className="w-full block" loading="lazy" />
      </button>
      {open && <ZoomDialog item={{ src, alt }} onClose={() => setOpen(false)} />}
    </>
  );
};

export const AutoVideo = ({ name, caption, testid }) => {
  const ref = useRef(null);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const v = ref.current;
    const io = new IntersectionObserver(([e]) => (e.isIntersecting ? v.play().catch(() => {}) : v.pause()), { threshold: 0.25 });
    io.observe(v);
    return () => io.disconnect();
  }, []);
  const src = `/tech/media/benchmark/videos/${name}.mp4`;
  return (
    <figure className="m-0">
      <video ref={ref} muted playsInline loop preload="metadata" poster={`/tech/media/benchmark/videos/${name}.jpg`} src={src}
        onClick={() => setOpen(true)} title="Click to enlarge"
        className="w-full rounded-xl border border-white/10 bg-black block cursor-zoom-in hover:border-[#FF7A00]/40 transition-colors" data-testid={testid} />
      <figcaption className="text-xs text-white/45 mt-2">{caption}</figcaption>
      {open && <ZoomDialog item={{ src, video: true }} onClose={() => setOpen(false)} />}
    </figure>
  );
};
